<!--suppress TypeScriptUnresolvedVariable -->
<div *ngIf="constructor.name.length > 1" class="component-name">>> {{constructor.name}} <<</div>
<div class="download-popup" *ngIf="this.pdf.blobTmpUrl">
    If your download has not started automatically, please click the button below.
    <div class="buttons">
        <p-button label="Close" icon="pi pi-times" (click)="this.pdf.blobTmpUrl = undefined"/>
        <p-button label="Download" icon="pi pi-download" severity="warning" (click)="downloadPo()"/>
    </div>
</div>
<div *ngIf="!gettingSignature" class="po-header">
    <div class="po-header-toolbar-container">
        <div class="po-batch">
            <p-sidebar 
                appendTo="body"
                [(visible)]="sidebarVisible"
                [style]="{backgroundColor: '#CFD5EA'}"
                >
                <div>
                    <div style="display: flex; flex-wrap: wrap; gap: 4px">
                        <p-button label="Show Metals" icon="fa fa-balance-scale" severity="warning" (click)="showMetals()" *ngIf="authManager.currentUser.showPgmsWeight"/>
                        <p-button *ngIf="authManager.currentUser.deletePurchaseOrder && !authManager.currentUser.isGlobalReader" severity="danger" (click)="deletePO()" icon="pi pi-trash" label="Remove"></p-button>
                        <p-button *ngIf="!poManager.current.isLocked && authManager.currentUser.createPurchaseOrder && !authManager.currentUser.isGlobalReader" (click)="updatePrices()">Update Prices</p-button>
                        <p-button severity="secondary" (click)="closePO()">Close PO</p-button>
                    </div>
                    <hr *ngIf="authManager.currentUser.vendorId == null"/>
                    <div style="display: flex; flex-direction: column;" *ngIf="authManager.currentUser.vendorId == null">
                        <span>Batch number:</span>
                        <div style="display: flex; gap: 4px;">
                            <div>
                                <p-dropdown
    (onChange)="onBatchSave()"
    [showClear]="true"
    [filter]="true"
    [disabled]="authManager.currentUser.isGlobalReader"
    [options]="batches"
    [(ngModel)]="selectedBatch"
    optionLabel="number"
    optionValue="id"
    placeholder="Select Batch"
    [style]="{maxWidth: '250px'}"
    [loading]="batchesLoading"
    appendTo="body"
    [virtualScroll]="true"
    [virtualScrollItemSize]="38"
    [virtualScrollOptions]="batchesScrollerOptions">
                                    <ng-template pTemplate="filter">
                                        <div class="vendors-filter-content">
                                            <div class="p-inputgroup" (click)="$event.stopPropagation()" style="border: 1px solid rgba(0,0,0,.5); border-radius: 8px;">
                                                <input
                                                    class="no-focus-input"
                                                    style="border: none; background-color: rgba(0,0,0,0);"
                                                    type="text"
                                                    placeholder="Filter"
                                                    [(ngModel)]="batchesFilterValue"
                                                    (keyup.enter)="onFilterBatches()" />
                                                <span><i style="padding: 0 5px; padding-top: 3px; cursor: pointer" class="pi pi-times" (click)="onClearBatchesFilter()"></i></span>
                                            </div>
                                            <div>
                                                <p-button label="Apply filter" size="small" (click)="onFilterBatches()"/>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                            <!-- <p-button icon="pi pi-save" *ngIf="selectedBatch != poManager.current.batchId" (click)="onBatchSave()"></p-button> -->
                        </div>
                    </div>
                    <hr *ngIf="authManager.currentUser.vendorId == null"/>
                    <div style="display: flex; flex-direction: column;" *ngIf="authManager.currentUser.vendorId == null">
                        <span>Hedge Contract:</span>
                        <div style="display: flex; gap: 4px;">
                            <div>
                                <p-dropdown
                                    [disabled]="authManager.currentUser.isGlobalReader"
                                    *ngIf="authManager.currentUser.createPurchaseOrder"
                                    [filter]="true"
                                    [options]="availableHedges"
                                    [(ngModel)]="selectedHedge"
                                    optionLabel="number"
                                    placeholder="Select Contract"
                                    [showClear]="true"
                                    [loading]="hedgesLoading"
                                    appendTo="body"
                                    [virtualScroll]="true"
                                    [virtualScrollItemSize]="38"
                                    [virtualScrollOptions]="hedgesScrollerOptions"
                                    (onChange)="onHedgeChange($event)">
                                    <ng-template pTemplate="filter">
                                        <div class="vendors-filter-content">
                                            <div class="p-inputgroup" (click)="$event.stopPropagation()" style="border: 1px solid rgba(0,0,0,.5); border-radius: 8px;">
                                                <input
                                                    class="no-focus-input"
                                                    style="border: none; background-color: rgba(0,0,0,0);"
                                                    type="text"
                                                    placeholder="Filter"
                                                    [(ngModel)]="hedgesFilterValue"
                                                    (keyup.enter)="onFilterHedges()" />
                                                <span><i style="padding: 0 5px; padding-top: 3px; cursor: pointer" class="pi pi-times" (click)="onClearHedgesFilter()"></i></span>
                                            </div>
                                            <div>
                                                <p-button label="Apply filter" size="small" (click)="onFilterHedges()"/>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div style="display: flex; flex-direction: column;">
                        <!-- <div class="button" *ngIf="!updateNotesVisible && !authManager.currentUser.isGlobalReader" (click)="updateNotesVisible = true"><span class="pi pi-plus"></span>Add notes</div> -->
                        <div class="notes visible" >
                            <span>Notes:</span>
                            <textarea #notes rows="{{deviceManager.isMobile ? 2 : 4}}" [value]="poManager.current.notes ?? ''" style="width: 100%" [disabled]="authManager.currentUser.isGlobalReader"></textarea>
                            <!-- <span (click)="onUpdateNotes(notes.value)" class="button"><span class="pi pi-save"></span>Update notes</span> -->
                            <p-button label="Save Notes" icon="pi pi-save" [disabled]="authManager.currentUser.isGlobalReader" (click)="onUpdateNotes(notes.value)"></p-button>
                        </div>
                    </div>
                </div>
            </p-sidebar>
            <!-- <span>Batch number:</span>
            <div>
                <p-dropdown [disabled]="authManager.currentUser.isGlobalReader" [options]="batches" [(ngModel)]="selectedBatch" optionLabel="number" optionValue="id" placeholder="Select batch"/>
            </div>
            <p-button icon="pi pi-save" *ngIf="selectedBatch != poManager.current.batchId" (click)="onBatchSave()"></p-button> -->
        </div>
        <div class="po-header-toolbar" [hidden]="editedItemCopy != null">
            <p-button icon="fa fa-cog" (click)="sidebarVisible = true" ></p-button>
            <!-- <p-button label="Metals" icon="fa fa-balance-scale" severity="warning" (click)="showMetals()" *ngIf="authManager.currentUser.showPgmsWeight"/> -->
            <p-button *ngIf="authManager.currentUser.isUberAdmin && !authManager.currentUser.isGlobalReader && poManager.current.isLocked && poManager.current.signaturePageType !== null && !isEuLaunch && poManager.current.newVersion" icon="fa fa-edit" label="Admin edit" (click)="adminEditPageType = poManager.current.signaturePageType"></p-button>
            <p-button *ngIf="LocalCacheManager.transactionQueue.length > 0 && !authManager.currentUser.isGlobalReader" severity="danger" (click)="refresh()"><i class="fa fa-sync" style="margin-left: 5px; margin-right: 5px;"></i></p-button>
            <p-button *ngIf="authManager.currentUser.createPurchaseOrder || poManager.current.isLocked" (click)="printMenu.toggle($event)" icon="fa fa-print"></p-button>
            <!-- <p-button *ngIf="authManager.currentUser.deletePurchaseOrder && !authManager.currentUser.isGlobalReader" severity="danger" (click)="deletePO()" icon="pi pi-trash"></p-button> -->
            <p-button *ngIf="poManager.current.isLocked && authManager.currentUser.unlockPurchaseOrder && !authManager.currentUser.isGlobalReader" (click)="unlock()" icon="fa fa-unlock-alt" label="{{deviceManager.isMobile ? '' : 'Unlock'}}"></p-button>
            <p-button *ngIf="!poManager.current.isLocked && authManager.currentUser.createPurchaseOrder && !authManager.currentUser.isGlobalReader" (click)="addParts()">Add Parts</p-button>
            <!-- <p-button *ngIf="!poManager.current.isLocked && authManager.currentUser.createPurchaseOrder && !authManager.currentUser.isGlobalReader" (click)="updatePrices()">Update Prices</p-button> -->
            <p-button *ngIf="!poManager.current.isLocked && poManager.current.isShared && poManager.current.isInventoryList && !authManager.currentUser.isGlobalReader" severity="success" (click)="createPo()" icon="pi pi-plus" label="Create PO"></p-button>
            <!-- <p-button severity="secondary" (click)="closePO()">Close PO</p-button> -->
            <p-button severity="success" (click)="closeView()" icon="fa fa-times"></p-button>
        </div>
    </div>
    <div class="po-header-general-area po-header-section">
        <div class="po-number" (click)="headerDisplayed = !headerDisplayed">
            <div><i class="fa" [class]="headerDisplayed ? 'fa-caret-down' : 'fa-caret-right'"></i></div>
            <div style="margin-left: 10px;"><span *ngIf="!deviceManager.isMobile">PO #: </span>{{poManager.current.number}}</div>
        </div>
        <!-- <div class="gap"></div> -->
        <div class="po-date">
            <span *ngIf="!deviceManager.isMobile">Purchase Date: </span>
            <p-calendar [styleClass]="'calendar-style ' + ThemeManager.theme" inputStyleClass="calendar-input-style"
                        [(ngModel)]="poManager.current.purchaseDate" inputId="icon" dateFormat="yy-mm-dd" (ngModelChange)="setPurchaseDate()" 
                        [showIcon]="false" [disabled]="true"></p-calendar>
            <div class="location" style="font-size: .8rem;" *ngIf="authManager.currentUser.isUberAdmin && poManager.current.isLocked">
                <span style="margin-right: 4px;" *ngIf="!deviceManager.isMobile">Lock location:</span> 
                <a *ngIf="poManager.current.geolocationAvailable" target="_blank" href="https://maps.google.com/?q={{poManager.current.latitude}},{{poManager.current.longitude}}">{{poManager.current.latitude}} {{poManager.current.longitude}}</a>
                <span *ngIf="!poManager.current.geolocationAvailable">Unavailable</span>
            </div>
        </div>
        <!-- <div class="gap"></div> -->
        
        <div class="po-total">
            <div>
                <span *ngIf="!deviceManager.isMobile">Total: </span>{{poManager.current.totalPrice + poManager.current.totalAdjustment | currency:poManager.current.currency:true}}
            </div>
            <div style="font-size: .8rem" *ngIf="poManager.current.isLocked">
                <span *ngIf="!deviceManager.isMobile">Adjustment: </span>
                <span *ngIf="deviceManager.isMobile">Adj: </span>
                {{poManager.current.totalAdjustment | currency:poManager.current.currency:true}}
            </div>
        </div>
    </div>
            <!-- <div class="po-batch" *ngIf="deviceManager.isMobile">
            <span>Batch number:</span>
            <div>
                <p-dropdown [disabled]="authManager.currentUser.isGlobalReader" [options]="batches" [(ngModel)]="selectedBatch" optionLabel="number" optionValue="id" placeholder="Select batch"/>
            </div>
            <p-button icon="pi pi-save" *ngIf="selectedBatch != poManager.current.batchId" (click)="onBatchSave()"></p-button>
        </div> -->
    <div *ngIf="headerDisplayed" class="po-header-vendor-location-area">
        <div class="po-vendor-area po-header-section">
            <div class="data-completion" *ngIf="poManager.current.hasCompleteData === false">
                <i title="Vendor data incomplete" style="color: red;" class="pi pi-exclamation-triangle" (click)="op.toggle($event)"></i>
                <span (click)="op.toggle($event)">Data incomplete</span>
            </div>
            <div class="first-vendor-line">
                <div>Vendor:</div>
                <p-dropdown
                    *ngIf="!poManager.current.isLocked && authManager.currentUser.createPurchaseOrder"
                    optionLabel="name"
                    [disabled]="authManager.currentUser.isGlobalReader"
                    appendTo="body" 
                    placeholder="Change Vendor" 
                    [options]="vendors"
                    [loading]="vendorListLoading"
                    [(ngModel)]="selectedVendor" 
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="38"
                    [virtualScrollOptions]="vendorsScrollerOptions"
                    [panelStyleClass]="vendorsLoaded ? 'loaded' : ''"
                    [filter]="true" 
                    (onChange)="changeVendor($event)"
                    >
                <ng-template pTemplate="selectedItem">
            <span>{{selectedVendor.name}}</span>
        </ng-template>

        <ng-template pTemplate="filter" let-options="options">
            <div class="vendors-filter-content">
                <div class="p-inputgroup" (click)="$event.stopPropagation()" style="border: 1px solid rgba(0,0,0,.5); border-radius: 8px;">
                    <input 
                    class="no-focus-input"
                    style="border: none; background-color: rgba(0,0,0,0);"
                    type="text"
                    placeholder="Filter" 
                    [(ngModel)]="vendorsFilterValue"
                    (keyup.enter)="onFilterVendors($event)" />
                    <span><i style="padding: 0 5px; padding-top: 3px; cursor: pointer" class="pi pi-times" (click)="onClearVendorsFilter()"></i></span>
                    <!-- <span><i style="padding: 0 5px; padding-top: 4px" class="pi pi-search"></i></span> -->
                </div>
                <div>
                    <p-button label="Apply filter" size="small" (click)="onFilterVendors($event)"/>
                </div>
            </div>
        </ng-template>
                </p-dropdown>

            </div>
            <div>{{poManager.current.vendorName}}</div>
            <div>{{poManager.current.vendor.address}}</div>
            <div>{{poManager.current.vendor.city}} {{poManager.current.vendor.state}} {{poManager.current.vendor.zip}}</div>
        </div>
        <div *ngIf="poManager.current.location != null" class="po-location-area po-header-section">
            <div>Ship To:</div>
            <div>{{authManager.currentUser.purchaseOrderLocationName || poManager.current.location.name}}</div>
            <div>{{authManager.currentUser.purchaseOrderAddress || poManager.current.location.address}}</div>
            <div>{{authManager.currentUser.purchaseOrderCity || poManager.current.location.city}}
                {{authManager.currentUser.purchaseOrderState || poManager.current.location.state}}
                {{authManager.currentUser.purchaseOrderZip || poManager.current.location.zip}}</div>
        </div>
    </div>

    <!-- <div class="po-hedge-area" *ngIf="poManager.current.vendorId">
        <span>Hedge Contract:</span>
        <span *ngIf="poManager.current.isLocked && !authManager.currentUser.isUberAdmin">
            {{ poManager.current.hedgeContractNumber ?? 'None' }}
        </span>
        <p-dropdown
            *ngIf="!poManager.current.isLocked && authManager.currentUser.createPurchaseOrder && !authManager.currentUser.isGlobalReader"
            [options]="availableHedges"
            [(ngModel)]="selectedHedge"
            optionLabel="contractNumber"
            placeholder="Select Hedge Contract"
            [showClear]="true"
            [loading]="hedgesLoading"
            appendTo="body"
            (onChange)="onHedgeChange($event)">
        </p-dropdown>
        <p-dropdown
            *ngIf="poManager.current.isLocked && authManager.currentUser.isUberAdmin && !authManager.currentUser.isGlobalReader"
            [options]="availableHedges"
            [(ngModel)]="selectedHedge"
            optionLabel="contractNumber"
            placeholder="Select Hedge Contract"
            [showClear]="true"
            [loading]="hedgesLoading"
            appendTo="body"
            (onChange)="onHedgeChange($event)">
        </p-dropdown>
    </div> -->

    <div class="po-header-images-notes-area">
        <!-- <div class="po-header-notes-area">
            <div class="button" *ngIf="!updateNotesVisible && !authManager.currentUser.isGlobalReader" (click)="updateNotesVisible = true"><span class="pi pi-plus"></span>Add notes</div>
            <div class="notes visible" *ngIf="updateNotesVisible"><textarea #notes rows="{{deviceManager.isMobile ? 2 : 4}}" [value]="poManager.current.notes ?? ''"></textarea><span (click)="onUpdateNotes(notes.value)" class="button"><span class="pi pi-save"></span>Update notes</span></div>
        </div> -->
        <div class="po-header-image-area">
            <p-button *ngIf="(poManager.current.imageUrls?.length ?? 0) > 1" (click)="onDownloadAll()" style="margin-right: 10px;">Download all</p-button>
            <p-button icon="pi pi-upload" (click)="attachmentBoxVisible = true" *ngIf="!authManager.currentUser.isGlobalReader"></p-button>
            <div *ngFor="let url of poManager.current.imageUrls; let index = index" class="icon-and-trash">
                <i class="fas fa-2x fa-file-image" (click)="onImageClicked(index)" (mouseover)="imageHoverIndex = index" (mouseleave)="imageHoverIndex = null"></i>
                <i *ngIf="!poManager.current.isLocked" class="fa fa-trash" (click)="onImageRemoved(index)" ></i>
            </div>
            <div *ngIf="!deviceManager.isMobile && imageHoverIndex != null && ImageApiService.isImageUrl(poManager.current.imageUrls[imageHoverIndex])"
                 class="po-image" [style.margin-left.px]="250 + (imageHoverIndex * 35)">
                <img [src]="poManager.current.imageUrls[imageHoverIndex]"/>
            </div>
        </div>
    </div>
    <!-- <div class="po-header-image-area">
        <p-fileUpload #fileUpload mode="basic" chooseIcon="pi pi-upload" [disabled]="poManager.current.isLocked"
                      [showUploadButton]="false" [showCancelButton]="false" [customUpload]="true" (onSelect)="uploadImageSelected($event)">
            <ng-template pTemplate="toolbar"></ng-template>
            <ng-template let-file pTemplate="file"></ng-template>
            <ng-template pTemplate="content"></ng-template>
        </p-fileUpload>
        <div *ngFor="let url of poManager.current.imageUrls; let index = index" class="icon-and-trash">
            <i class="fas fa-2x fa-file-image" (click)="onImageClicked(index)" (mouseover)="imageHoverIndex = index" (mouseleave)="imageHoverIndex = null"></i>
            <i *ngIf="!poManager.current.isLocked" class="fa fa-trash" (click)="onImageRemoved(index)" ></i>
        </div>
    </div>

    <div *ngIf="!deviceManager.isMobile && imageHoverIndex != null && ImageApiService.isImageUrl(poManager.current.imageUrls[imageHoverIndex])"
         class="po-image" [style.margin-left.px]="250 + (imageHoverIndex * 35)">
        <img [src]="poManager.current.imageUrls[imageHoverIndex]"/>
    </div> -->
</div>

<div *ngIf="!gettingSignature" class="po-body">
    <!-- Converters -->
    <div *ngIf="poManager.current.totalNumConverters > 0" class="po-table-section" [style.minHeight.px]="convertersDisplayed ? minTableHeight(poManager.current.lineItemsConverter) : 30">
        <div class="po-table-title" (click)="convertersDisplayed = !convertersDisplayed">
            <div><i class="fa" [class]="convertersDisplayed ? 'fa-caret-down' : 'fa-caret-right'"></i></div>
            <div>Converters</div>
        </div>
        <div *ngIf="deviceManager.isMobile && convertersDisplayed" class="mobile-list-container">
            <div class="mobile-table">
                <div *ngFor="let lineItem of poManager.current.lineItemsAllConverters" class="card" [ngSwitch]="lineItem.type">

                    <!-- Converter -->
                    <ng-container *ngSwitchCase="PurchaseOrderTransactionPartType.Converter">
                        <div class="mobile-row"><div>#: {{lineItem.converterPartNumberReadable}}</div><div>Cat: {{lineItem.converterGroupName}}</div></div>
                        <div *ngIf="editedItemCopy == null || lineItem.id !== editedItemCopy.id" class="mobile-row">
                            <div>Metal: {{lineItem.levelPercentageText}}</div><div>Quantity: {{lineItem.quantity}}</div>
                        </div>
                        <div *ngIf="editedItemCopy != null && lineItem.id === editedItemCopy.id" class="mobile-row">
                            <div><ng-container *ngTemplateOutlet="levelInput; context: { lineItem: lineItem }"></ng-container></div>
                            <div><ng-container *ngTemplateOutlet="quantityInput; context: { lineItem: lineItem }"></ng-container></div>
                        </div>
                    </ng-container>

                    <!-- Custom -->
                    <ng-container *ngSwitchCase="PurchaseOrderTransactionPartType.Custom">
                        <div class="mobile-row">
                            <div style="display:flex; flex-direction:column;">
                                <span>{{lineItem.vin ?? '&lt;Custom&gt;'}}</span>
                                <span *ngIf="lineItem.customPartNumber" style="font-size: .75em; margin-top:-2px; line-height:.8em;">Part number: {{lineItem.customPartNumber}}</span>
                            </div>
                            <div>Cat: {{lineItem.converterGroupName}}</div>
                        </div>
                        <div *ngIf="editedItemCopy == null || lineItem.id !== editedItemCopy.id" class="mobile-row">
                            <div>Quantity: {{lineItem.quantity}}</div>
                        </div>
                        <div *ngIf="editedItemCopy != null && lineItem.id === editedItemCopy.id" class="mobile-row">
                            <div><ng-container *ngTemplateOutlet="quantityInput; context: { lineItem: lineItem }"></ng-container></div>
                        </div>
                    </ng-container>

                    <!-- No-Number -->
                    <ng-container *ngSwitchCase="PurchaseOrderTransactionPartType.NoNumber">
                        <div class="mobile-row"><div>#: {{lineItem.converterPartNumberReadable}}</div><div>Cat: {{lineItem.converterGroupName}}</div></div>
                        <div *ngIf="editedItemCopy == null || lineItem.id !== editedItemCopy.id" class="mobile-row">
                            <div>Metal: {{lineItem.levelPercentageText}}</div><div>Quantity: {{lineItem.quantity}}</div>
                        </div>
                        <div *ngIf="editedItemCopy != null && lineItem.id === editedItemCopy.id" class="mobile-row">
                            <div><ng-container *ngTemplateOutlet="levelInput; context: { lineItem: lineItem }"></ng-container></div>
                            <div><ng-container *ngTemplateOutlet="quantityInput; context: { lineItem: lineItem }"></ng-container></div>
                        </div>
                    </ng-container>

                    <!-- Categories -->
                    <ng-container *ngSwitchCase="PurchaseOrderTransactionPartType.Category">
                        <div class="mobile-row"><div>#: {{lineItem.converterPartNumberReadable}}</div><div>Cat: {{lineItem.converterGroupName}}</div></div>
                        <div *ngIf="editedItemCopy == null || lineItem.id !== editedItemCopy.id" class="mobile-row">
                            <div>Quantity: {{lineItem.quantity}}</div>
                            <div *ngIf="!lineItem.categoryHasCustomPrices">Metal: {{lineItem.levelPercentageText}}</div>
                        </div>
                        <div *ngIf="editedItemCopy != null && lineItem.id === editedItemCopy.id" class="mobile-row">
                            <ng-container *ngTemplateOutlet="quantityInput; context: { lineItem: lineItem }"></ng-container>
                            <div *ngIf="!lineItem.categoryHasCustomPrices">Metal: {{lineItem.levelPercentageText}}</div>
                        </div>
                    </ng-container>

                    <!-- All converter types -->
                    <div class="mobile-row"><div>Price/item: {{lineItem.pricePerItem | currency:poManager.current.currency:false}}</div>
                        <div style="font-weight: bold">TOTAL: {{lineItem.totalPrice | currency:poManager.current.currency:false}}</div>
                    </div>

                    <div *ngIf="!poManager.uploadingTransactions" class="mobile-buttons">
                        <span *ngIf="editedItemCopy == null && lineItem.id > 0 && !authManager.currentUser.isGlobalReader" class="p-button p-button-text" (click)="onRowEditInit(lineItem)"><i class="pi pi-pencil"></i></span>
                        <span *ngIf="editedItemCopy != null && lineItem.id === editedItemCopy.id && !authManager.currentUser.isGlobalReader" class="p-button p-button-text p-button-success" (click)="onRowEditSave(poManager.current.lineItemsAllConverters, lineItem)"><i class="pi pi-check"></i></span>
                        <span *ngIf="editedItemCopy != null && lineItem.id === editedItemCopy.id && !authManager.currentUser.isGlobalReader" class="p-button p-button-text p-button-danger" (click)="onRowEditCancel(poManager.current.lineItemsAllConverters)"><i class="pi pi-times"></i></span>
                        <span *ngIf="editedItemCopy == null && lineItem.id > 0 && !authManager.currentUser.isGlobalReader" class="p-button p-button-text" (click)="onDeleteLineItem(poManager.current.lineItemsAllConverters, lineItem)"><i class="fas fa-trash"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!deviceManager.isMobile && convertersDisplayed" class="po-table-container">
            <p-table [value]="poManager.current.lineItemsAllConverters" styleClass="list-table p-datatable-sm" [columns]="converterColumns"
                     [scrollable]="true" scrollHeight="flex" sortField="lastUpdated" [sortOrder]="-1" editMode="row" dataKey="id">
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of converterColumns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="col.sortDisabled || false" [style.width]="col.width">
                            <div [style]="col.style">{{col.header}} <p-sortIcon *ngIf="!(col.sortDisabled || false)" [field]="col.field"></p-sortIcon>
                            </div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-lineItem let-editing="editing" let-index="rowIndex">
                    <tr [pEditableRow]="lineItem" [class]="index % 2 === 0 ? 'even' : 'odd'">
                        <td *ngFor="let col of converterColumns" [ngSwitch]="col.field" [style.width]="isMobile ? '100%' : col.width" [style]="col.style">
                            <div *ngSwitchCase="'converterPartNumber'">
                                <div [ngSwitch]="lineItem.type">
                                    <div *ngSwitchCase="PurchaseOrderTransactionPartType.Converter">{{lineItem.converterPartNumberReadable}}</div>
                                    <div *ngSwitchCase="PurchaseOrderTransactionPartType.Custom" style="display:flex; flex-direction:column;">
                                        <span>{{lineItem.vin ?? '&lt;Custom&gt;'}}</span>
                                        <span *ngIf="lineItem.customPartNumber" style="font-size: .75em">Part number: {{lineItem.customPartNumber}}</span>
                                    </div>
                                    <div *ngSwitchCase="PurchaseOrderTransactionPartType.NoNumber">{{lineItem.converterPartNumberReadable}}</div>
                                    <div *ngSwitchCase="PurchaseOrderTransactionPartType.Category">{{lineItem.converterPartNumberReadable}}</div>
                                </div>
                            </div>
                            <p-cellEditor *ngSwitchCase="'quantity'">
                                <ng-template pTemplate="input"><ng-container *ngTemplateOutlet="quantityInput; context: { lineItem: lineItem }"></ng-container></ng-template>
                                <ng-template pTemplate="output">{{lineItem.quantity}}</ng-template>
                            </p-cellEditor>
                            <ng-container *ngSwitchCase="'levelPercentageText'">
                                <ng-container *ngIf="lineItem.type === PurchaseOrderTransactionPartType.Converter || lineItem.type === PurchaseOrderTransactionPartType.NoNumber">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input"><ng-container *ngTemplateOutlet="levelInput; context: { lineItem: lineItem }"></ng-container></ng-template>
                                        <ng-template pTemplate="output">{{lineItem.levelPercentageText}}</ng-template>
                                    </p-cellEditor>
                                </ng-container>
                                <ng-container *ngIf="lineItem.type === PurchaseOrderTransactionPartType.Category">
                                    <p-cellEditor *ngIf="!lineItem.categoryHasCustomPrices && !lineItem.byPound">
                                        <ng-template pTemplate="input"><ng-container *ngTemplateOutlet="levelInput; context: { lineItem: lineItem }"></ng-container></ng-template>
                                        <ng-template pTemplate="output">{{lineItem.levelPercentageText}}</ng-template>
                                    </p-cellEditor>
                                    <p-cellEditor *ngIf="lineItem.byPound">
                                        <ng-template pTemplate="input"><ng-container *ngTemplateOutlet="poundsInput; context: { lineItem: lineItem }"></ng-container></ng-template>
                                        <ng-template pTemplate="output">{{lineItem.levelPercentageText}}</ng-template>
                                    </p-cellEditor>
                                    <div *ngIf="lineItem.categoryHasCustomPrices && !lineItem.byPound"><span style="font-style: italic">&lt;Custom&gt;</span></div>
                                </ng-container>
                            </ng-container>
                            <div *ngSwitchCase="'pricePerItem'">{{lineItem.pricePerItem | currency:poManager.current.currency}}</div>
                            <div *ngSwitchCase="'totalPrice'">{{lineItem.totalPrice | currency:poManager.current.currency}}</div>
                            <div *ngSwitchCase="'editColumn'" [hidden]="poManager.uploadingTransactions || poManager.current.isLocked || (editedItemCopy != null && editedItemCopy.id !== lineItem.id) || !authManager.currentUser.createPurchaseOrder" class="desktop-buttons">
                                <p-button *ngIf="!editing && lineItem.id > 0"  pInitEditableRow icon="pi pi-pencil" [text]="true" (click)="onRowEditInit(lineItem)"></p-button>
                                <p-button *ngIf="editing"  pSaveEditableRow icon="pi pi-check" class="p-button-success p-button-text" style="margin-right: .5em" (click)="onRowEditSave(poManager.current.lineItemsAllConverters, lineItem)"></p-button>
                                <p-button *ngIf="editing"  pCancelEditableRow icon="pi pi-times" class="p-button-danger p-button-text" (click)="onRowEditCancel(poManager.current.lineItemsAllConverters)"></p-button>
                                <p-button *ngIf="!editing && lineItem.id > 0"  icon="fas fa-trash" [text]="true" (click)="onDeleteLineItem(poManager.current.lineItemsAllConverters, lineItem)"></p-button>
                            </div>
                            <div *ngSwitchDefault>{{lineItem[col.field]}}</div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <!-- Non-Ferrous Parts -->
    <div *ngIf="poManager.current.lineItemsMiscellaneous.length > 0" class="po-table-section" [style.minHeight.px]="miscDisplayed ? minTableHeight(poManager.current.lineItemsMiscellaneous) : 30">
        <div class="po-table-title" (click)="miscDisplayed = !miscDisplayed">
            <div><i class="fa" [class]="miscDisplayed ? 'fa-caret-down' : 'fa-caret-right'"></i></div>
            <div>Non-Ferrous</div>
        </div>
        <div *ngIf="deviceManager.isMobile && miscDisplayed" class="mobile-list-container">
            <div class="mobile-table">
                <div *ngFor="let lineItem of poManager.current.lineItemsMiscellaneous" class="card">
                    <div class="mobile-row">
                        <div><i class="fa" [class]="lineItem.pricingType === PricingType.ByPiece ? 'fa-puzzle-piece' : 'fa-weight-hanging'"></i></div>
                        <div>{{lineItem.description}}</div>
                    </div>
                    <div *ngIf="editedItemCopy != null && lineItem.id === editedItemCopy.id" class="mobile-row">
                        <div><ng-container *ngTemplateOutlet="quantityInput; context: { lineItem: lineItem }"></ng-container></div>
                    </div>
                    <div *ngIf="editedItemCopy == null || lineItem.id !== editedItemCopy.id" class="mobile-row">
                        <div>Quantity: {{lineItem.quantity}}</div>
                    </div>
                    <div class="mobile-row"><div>Price/item: {{lineItem.pricePerItem | currency:poManager.current.currency:true}}</div>
                        <div style="font-weight: bold">TOTAL: {{lineItem.totalPrice | currency:poManager.current.currency:true}}</div>
                    </div>
                    <div *ngIf="!poManager.uploadingTransactions" class="mobile-buttons">
                        <span *ngIf="editedItemCopy == null && lineItem.id > 0" class="p-button p-button-text" (click)="onRowEditInit(lineItem)"><i class="pi pi-pencil"></i></span>
                        <span *ngIf="editedItemCopy != null && lineItem.id === editedItemCopy.id" class="p-button p-button-text p-button-success" (click)="onRowEditSave(poManager.current.lineItemsMiscellaneous, lineItem)"><i class="pi pi-check"></i></span>
                        <span *ngIf="editedItemCopy != null && lineItem.id === editedItemCopy.id" class="p-button p-button-text p-button-danger" (click)="onRowEditCancel(poManager.current.lineItemsMiscellaneous)"><i class="pi pi-times"></i></span>
                        <span *ngIf="editedItemCopy == null && lineItem.id > 0" class="p-button p-button-text" (click)="onDeleteLineItem(poManager.current.lineItemsMiscellaneous, lineItem)"><i class="fas fa-trash"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!deviceManager.isMobile && miscDisplayed" class="po-table-container">
            <p-table [value]="poManager.current.lineItemsMiscellaneous" styleClass="list-table p-datatable-sm" [columns]="miscColumns"
                     [scrollable]="true" scrollHeight="flex" sortField="lastUpdated" [sortOrder]="-1" editMode="row" dataKey="id">
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of miscColumns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="col.sortDisabled || false" [style.width]="col.width">
                            <div [style]="col.style">{{col.header}} <p-sortIcon *ngIf="!(col.sortDisabled || false)" [field]="col.field"></p-sortIcon>
                            </div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-lineItem let-editing="editing" let-index="rowIndex">
                    <tr [pEditableRow]="lineItem" [class]="index % 2 === 0 ? 'even' : 'odd'">
                        <td *ngFor="let col of miscColumns" [ngSwitch]="col.field" [style.width]="isMobile ? '100%' : col.width" [style]="col.style">
                            <div *ngSwitchCase="'pricingType'" style="text-align: left; margin-left: 20px;">
                                <span [ngSwitch]="lineItem.pricingType">
                                    <i *ngSwitchCase="PricingType.ByPiece" class="fa fa-puzzle-piece"></i>
                                    <i *ngSwitchCase="PricingType.ByPound" class="fa fa-weight-hanging"></i>
                                </span>
                            </div>
                            <p-cellEditor *ngSwitchCase="'quantity'">
                                <ng-template pTemplate="input"><ng-container *ngTemplateOutlet="quantityInput; context: { lineItem: lineItem }"></ng-container></ng-template>
                                <ng-template pTemplate="output">{{lineItem.quantity}}</ng-template>
                            </p-cellEditor>
                            <div *ngSwitchCase="'pricePerItem'">{{lineItem.pricePerItem | currency:poManager.current.currency:true}}</div>
                            <div *ngSwitchCase="'totalPrice'">{{lineItem.totalPrice | currency:poManager.current.currency:true}}</div>
                            <div *ngSwitchCase="'editColumn'" [hidden]="poManager.uploadingTransactions || poManager.current.isLocked || (editedItemCopy != null && editedItemCopy.id !== lineItem.id) || !authManager.currentUser.createPurchaseOrder" class="desktop-buttons">
                                <p-button *ngIf="!editing && lineItem.id > 0"  pInitEditableRow icon="pi pi-pencil" [text]="true" (click)="onRowEditInit(lineItem)"></p-button>
                                <p-button *ngIf="editing"  pSaveEditableRow icon="pi pi-check" class="p-button-success p-button-text" style="margin-right: .5em" (click)="onRowEditSave(poManager.current.lineItemsMiscellaneous, lineItem)"></p-button>
                                <p-button *ngIf="editing"  pCancelEditableRow icon="pi pi-times" class="p-button-danger p-button-text" (click)="onRowEditCancel(poManager.current.lineItemsMiscellaneous)"></p-button>
                                <p-button *ngIf="!editing && lineItem.id > 0"  icon="fas fa-trash" [text]="true" (click)="onDeleteLineItem(poManager.current.lineItemsMiscellaneous, lineItem)"></p-button>
                            </div>
                            <div *ngSwitchDefault>{{lineItem[col.field]}}</div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<p-overlayPanel #op>
    <div style="padding:0; margin: 0">
        <ul style="padding-left: 6px; margin: 0">
            <li *ngFor="let item of poManager.current.completnessMessage" style="font-size: .8rem">
                {{item}}
            </li>
        </ul>
    </div>
</p-overlayPanel>
<ng-template #quantityInput let-lineItem="lineItem">
    <p-inputNumber mode="decimal" [showButtons]="true" inputId="minmax-buttons" [min]="1" [max]="99999" [(ngModel)]="lineItem.quantity" styleClass="quantity-input"></p-inputNumber>
</ng-template>

<ng-template #levelInput let-lineItem="lineItem">
    <p-dropdown [options]="levelOptions" [(ngModel)]="lineItem.levelPercentage" optionLabel="label" optionValue="value" optionDisabled="inactive" appendTo="body" styleClass="level-percentage-input" [scrollHeight]="'300px'"></p-dropdown>
</ng-template>

<ng-template #poundsInput let-lineItem="lineItem">
    <p-inputNumber mode="decimal" [showButtons]="true" inputId="minmax-buttons" [min]="1" [max]="99999" [(ngModel)]="lineItem.levelPercentage" styleClass="quantity-input"></p-inputNumber>
</ng-template>

<ls-purchase-order-pdf #pdf [hidden]="!gettingSignature" (signatureCompleted)="onSignatureCompleted($event)" (generationCompleted)="onPdfGenerated($event)"></ls-purchase-order-pdf>
<!--<ls-compliance-signature *ngIf="gettingSignature" (completed)="onSignatureCompleted($event)"></ls-compliance-signature>-->

<!--<p-slideMenu #printMenu styleClass="print-popup-menu" [popup]="true" [model]="printMenuItems" [menuWidth]="280" [viewportHeight]="5 * 44 + 50"></p-slideMenu>-->
<!--<p-menu #printMenu styleClass="print-popup-menu" [popup]="true" [model]="printMenuItems" [style]="{'width': '280px' }"></p-menu>-->
<p-tieredMenu #printMenu styleClass="print-popup-menu" [popup]="true" [model]="printMenuItems" [style]="{'width': '280px' }" (onShow)="menuOnShow()"></p-tieredMenu>

<ls-admin-edit *ngIf="adminEditPageType != undefined" [pageType]="adminEditPageType" (complete)="adminEditPageType = null"></ls-admin-edit>
<ls-waiting-indicator *ngIf="busy || error" [error]="error" [@fadeInOut] (okClick)="onErrorDismissed()"></ls-waiting-indicator>

<div class="upload-image-box" #ImageBox *ngIf="attachmentBoxVisible">
    <div class="title">Add attachment<i *ngIf="attachmentWait" class="pi pi-spinner pi-spin"></i></div>
    <div class="content">
        <!-- <p-fileUpload #fileUpload mode="basic" chooseIcon="pi pi-upload" chooseLabel="Select attachment"
                      [showUploadButton]="false" [showCancelButton]="false" [customUpload]="true">
        </p-fileUpload> -->
        <span style="display: flex; align-items: center; gap: 8px;">
            <p-button label="Upload" icon="pi pi-upload" (click)="compressImage()"/>
            <span style="color: white">{{compressedImage?.fileName ?? ''}}</span>
        </span>
        <p-dropdown [options]="attachmentTypes" [(ngModel)]="seletedAttachmentType" optionLabel="friendlyName" optionValue="value"/>
    </div>
    <div class="buttons">
        <p-button label="Cancel" (click)="uploadImageSelected(true)"/>
        <p-button label="Upload" (click)="uploadImageSelected()" />
    </div>
</div>

<p-dialog header="Metals Weights" [modal]="true" [(visible)]="metals" >
    <div>
        <div>Platinum: {{metals?.ptWeight | number:'1.2-2'}} {{LocalCacheManager.units == 'kg' ? 'g' : 'toz'}}</div>
        <div>Palladium: {{metals?.pdWeight | number:'1.2-2'}} {{LocalCacheManager.units == 'kg' ? 'g' : 'toz'}}</div>
        <div>Rhodium: {{metals?.rhWeight | number:'1.2-2'}} {{LocalCacheManager.units == 'kg' ? 'g' : 'toz'}}</div>
        <div>Total Monolith: {{metals?.totalMonolithWeight | number:'1.2-2'}} {{LocalCacheManager.units == 'kg' ? 'g' : 'lbs'}}</div>
    </div>
    <div style="margin-top: 10px;display:flex; justify-content: flex-end; width: 100%">
        <p-button label="Close" (onClick)="metals = null" />
    </div>
</p-dialog>